import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aa2489b6")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_back_button, {
                    "default-href": "/tabs/home",
                    text: _ctx.$t('Cancel')
                  }, null, 8, ["text"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "primary" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _withModifiers(_ctx.onSubmit, ["prevent"]),
                    disabled: (! _ctx.newPhoto) || _ctx.confirmDelete
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "end",
                        icon: _ctx.checkmark
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Save')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ]),
                _: 1
              }),
              (_ctx.confirmDelete)
                ? (_openBlock(), _createBlock(_component_ion_title, { key: 0 }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Confirm Delete')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_title, { key: 1 }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Upload Image')), 1)
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          (!_ctx.newPhoto)
            ? (_openBlock(), _createBlock(_component_ion_grid, { key: 0 }, {
                default: _withId(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                        default: _withId(() => [
                          (_ctx.confirmDelete)
                            ? (_openBlock(), _createBlock(_component_ion_text, {
                                key: 0,
                                color: "danger"
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Are you sure you want to delete your custom background?  This action can not be undone.")), 1)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_ion_text, { key: 1 }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Here you can select a photo to use as the background for your homepage.")), 1)
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (! _ctx.confirmDelete)
                    ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_button, {
                                shape: "round",
                                onClick: _ctx.takePhotoClicked
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Take Photo")), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (! _ctx.confirmDelete)
                    ? (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_button, {
                                shape: "round",
                                onClick: _ctx.selectImageClicked
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Select Photo from Device")), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.confirmDelete)
                    ? (_openBlock(), _createBlock(_component_ion_row, { key: 2 }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_button, {
                                shape: "round",
                                color: "medium",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmDelete=false))
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Cancel")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.confirmDelete)
                    ? (_openBlock(), _createBlock(_component_ion_row, { key: 3 }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_button, {
                                color: "danger",
                                shape: "round",
                                onClick: _ctx.deleteImageClicked
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Confirm Delete")), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_row, { key: 4 }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_button, {
                                shape: "round",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmDelete=true))
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Delete Custom Image")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                  (_ctx.processing)
                    ? (_openBlock(), _createBlock(_component_ion_row, { key: 5 }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _createVNode(_component_ion_row, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_spinner)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_row, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_text, null, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("Processing image...")), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_ion_grid, { key: 1 }, {
                default: _withId(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_button, {
                            shape: "round",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.newPhoto=undefined))
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("Pick a Different Image")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withId(() => [
                          _createVNode("img", {
                            src: _ctx.newPhoto.data,
                            alt: "background image",
                            style: {"border":"1px solid var(--ion-color-primary)"}
                          }, null, 8, ["src"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})